module.exports = __webpack_public_path__ + "img/ico062.ab92eb44.svg";